import { Col, Form, Input, Label, Row } from 'reactstrap';
import { ProductTitle } from '../../../../../../utils/Constant';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../../../../ReduxToolkit/Hooks';
import FormEditors from './FormEditors';
import { setFormValue } from '../../../../../../ReduxToolkit/Reducers/AddProductSlice';
import SimpleMdeReact from 'react-simplemde-editor';

const ProductOne = ({
    productName,
    productDescription,
    setProducDetail
}: {
    productName?: string;
    productDescription?: string;
    setProducDetail: any;
}) => {
    return (
        <div className="sidebar-body">
            <Form>
                <Row className="g-2">
                    <Col xs="12">
                        <Label className="m-0">
                            {ProductTitle} <span className="txt-danger"> *</span>
                        </Label>
                    </Col>
                    <Col
                        xs="12"
                        className="custom-input">
                        <Input
                            type="text"
                            required
                            name="F"
                            value={productName}
                            onChange={(e) => setProducDetail({ name: e.target.value })}
                            // onChange={(e)=>dispatch(setFormValue({name:"userName",value:e.target.value}))}
                        />
                    </Col>
                    <Col xs="12">
                        <SimpleMdeReact
                            id="editor_container"
                            // options={{ spellChecker: false, autofocus: true }}
                            value={productDescription}
                            onChange={(e) => setProducDetail({ description: e })}
                        />
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default ProductOne;
